import { message, Flex, Form, Col, Row } from "antd";
import React, { useEffect, useState } from "react";
import CustomInput from "../../components/CustomInput";
import CustomButton from "../../components/CustomButton";
import { useSpin } from "../../components/SpinContext";
import { AddNewRole, DeleteRole, UpdateRole } from "../../api's/roles";
import { useNavigate } from "react-router-dom";
import { useToken } from "../../common/helper";
import { CustomTitle } from "../../components";
import { DeleteProduct } from "../../api's/onboarding";
import CustomDeleteModal from "./CustomDeleteModal";

function AddNewRoleForm({
  form,
  editData,
  setModalOpen,
  onClose,
  fetchAllRoles,
}) {
  const navigate = useNavigate();
  const { showSpin, hideSpin } = useSpin();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const { token, removeToken } = useToken();
  const isActionNeeded = editData?.is_connected_with_anything;

  const unauthorize = (error) => {
    if (error && error?.status === 401) {
      removeToken();
      navigate("/login");
    }
  };

  useEffect(() => {
    if (editData?.id) {
      form.setFieldsValue({ name: editData?.name });
    } else {
      form.resetFields();
    }
  }, [editData, form]);

  const onFinish = (values) => {
    //const name = form?.getFieldValue("name");
    if (values) {
      showSpin();
      //const model = name;
      let model = values;

      if (editData?.id) {
        model.id = editData?.id;
      }

      // const apiCall = editData?.id
      //   ? UpdateRole(token, editData.id, model)
      //   : AddNewRole(token, model);

      AddNewRole(token, model)
        .then((res) => {
          const data = res?.data ? res.data?.data : null;
          if (data?.is_success) {
            message.success(data?.message);
            onClose();
            fetchAllRoles();
          } else {
            message.error(data?.message || "Something went wrong");
          }
        })
        .catch((error) => {
          unauthorize(error);
        })
        .finally(() => {
          hideSpin();
        });
    }
  };

  const handleDelete = (record) => {
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = () => {
    setShowDeleteModal(false);
    if (editData.id) {
      showSpin();
      DeleteRole(editData.id, token)
        .then((res) => {
          const data = res?.data || null;
          if (data) {
            if (data.data?.is_success) {
              onClose();
              fetchAllRoles();
              message.success(data?.data?.message);
            } else {
              message.error(data?.data?.message);
            }
          }
        })
        .catch((error) => {
          unauthorize(error);
        })
        .finally(() => {
          hideSpin();
        });
    }
  };

  return (
    <>
      {/* <CustomTitle
        text={editData?.id ? "Edit role" : "Add role"}
        fontSize={24}
        fontWeight="700"
        lineHeight="32px"
        color="#000"
        marginBottom={24}
      /> */}
      <Form
        form={form}
        name="validateOnly"
        layout="vertical"
        onFinish={onFinish}
        autoComplete="off"
        className="drawer-children-h flex flex-col justify-between"
        style={{ display: "flex", flexDirection: "column", height: "100%" }}
      >
        <div
          style={{
            position: "absolute",
            top: "40px",
            paddingTop: "0px",
            left: "0",
          padding: "0px 32px",
            width: "100%",
            background: "#fff",
            zIndex: "2",
          }}
        >
          <CustomTitle
            text={editData?.id ? "Edit role" : "Add role"}
            fontSize={20}
            fontWeight="700"
            lineHeight="32px"
            color="#000"
            marginBottom={0}
          />
        </div>
        <div
          style={{
            flex: 1,
            // overflowY: "auto",
            paddingBottom: "130px",
            paddingTop: "16px",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
          className="custom-scrollbar"
        >
          <Row gutter={[16, 14]}>
            <Col span={24}>
              <Form.Item
            className="custom-input form-input-style"
                label="Name"
                name="name"
                rules={[
                  { required: true, message: "Please enter role name" },
                  {
                    type: "string",
                    min: 3,
                    message: "Role name must be at least 3 characters long",
                  },
                ]}
                style={{ marginBottom: "0px", width: "100%" }}
              >
                <CustomInput
                  placeholder="e.g., Partner, Driver"
                  bgColor="#F3F3F3"
                  borderRadius={8}
                  height={36}
                  marginBottom={0}
                  border="none"
                  fontSize={14}
                  lineHeight="20px"
                  color="#000"
                />
              </Form.Item>
            </Col>
          </Row>
        </div>

        <div
          style={{
            background: "#fff",
            position: "absolute",
            bottom: "0",
            left: "0",
            width: "100%",
            padding: "0 24px 24px",
          }}
        >
          <Row gutter={[0, 8]} style={{ marginTop: "0" }}>
            <CustomButton
              key="button1"
              text="Save"
              bgColor="#000"
              htmlType="submit"
              color="#fff"
              fontSize="16px"
              fontWeight="600"
              boxShadow="none"
              height="48px"
              borderRadius={"8px"}
              width="100%"
            />

            {editData?.is_delete && (
              <>
                {editData?.id && (
                   <CustomButton
                   key={`button-${editData.id}`}
                   text="Remove"
                   bgColor="#f3f3f3"
                   color="#000"
                   fontSize="16px"
                   fontWeight="600"
                   boxShadow="none"
                   height="48px"
                   borderRadius={"8px"}
                   width="100%"
                   border="none"
                   // marginTop="8px"
                   // marginBottom="8px"
                   onClick={() => handleDelete()}
                 />
                )}
              </>
            )}

            <CustomButton
              key="button3"
              text="Cancel"
              bgColor="transparent"
              color="#000"
              fontSize="16px"
              fontWeight="600"
              boxShadow="none"
              height="48px"
              
              width="100%"
              border="none"
            // marginTop="8px"
              // marginBottom="8px"
              onClick={onClose}
            />
          </Row>
        </div>
      </Form>
      <CustomDeleteModal
        visible={showDeleteModal}
        onConfirm={() => handleConfirmDelete()}
        onClose={() => setShowDeleteModal(false)}
        title={isActionNeeded ? "Action needed" : `Remove role`}
        message={
          isActionNeeded
            ? "Roles with active users cannot be removed. First, change role of users before removing."
            : `All data assigned to this role will be removed.`
        }
        cancelText={isActionNeeded ? "Close" : "Cancel"}
        confirmText={isActionNeeded ? null : "Remove"}
        confirmColor={`#DE1135`}
      />
    </>
  );
}

export default AddNewRoleForm;
